import styled from 'styled-components'

export const IconRow = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;

	> svg {
		height: 22px;
	}
`
